module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/se-4984ae470ed69178af1dc26d6978f38f.svg";